import {
  RECOMMENDED_CONTENT_TYPES,
  ContentRecommendationList,
} from '@hivebrite/design-system/ContentRecommendation';
import type { ContentRecommendationType } from '@hivebrite/design-system/ContentRecommendation';
import { Divider } from '@hivebrite/design-system/Divider';

import { useNavigateToNewsDetail } from 'hb-react/frontoffice/apps/NewsIndex/hooks/useNavigateToNewsDetail';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useGetContentRecommendations } from 'hb-react/shared/components/ContentRecommendation/hooks/useGetContentRecommendation';

interface ContentRecommendationProps {
  contentId: number;
  contentType: RECOMMENDED_CONTENT_TYPES;
}

export const ContentRecommendation = ({
  contentId,
  contentType,
}: ContentRecommendationProps) => {
  const { topicId } = useTopicContext();
  const { onClick: navigateToNews } = useNavigateToNewsDetail();

  const { data: contentItems, isLoading } = useGetContentRecommendations({
    contentId,
    topicId,
    type: contentType,
  });

  const handleClickOnRecommendedItem = (
    recommendedContent: ContentRecommendationType,
  ) => {
    switch (recommendedContent.contentType) {
      case RECOMMENDED_CONTENT_TYPES.NEWS:
        navigateToNews(recommendedContent.id);
        break;
      default:
        break;
    }
  };

  if (!isLoading && contentItems.length === 0) {
    return null;
  }

  return (
    <>
      <Divider mb={0} />
      <ContentRecommendationList
        contentItems={contentItems}
        isLoading={isLoading}
        onItemClick={handleClickOnRecommendedItem}
      />
    </>
  );
};
